/*
  <SpeakerHero
    person={foredragsholdere}
    talktitle={true}
    title="mastering Continuous Innovation"
    details={true}
    time="10:15 — 11:00"
    day="Thursday"
  />
*/

import React from "react";
import Plx from "react-plx";
import Hyphenated from "react-hyphen";

// Primitives
// import Grid from "../primitives/Grid";
import WrapRotation from "../primitives/WrapRotation";
import EmojiIcon from "../primitives/EmojiIcon";

const SpeakerHero = props => {
  // if (props.person.lenght != 1) return null
  //onst { person[] } = props

  const name = [
    {
      start: "self",
      startOffset: 0,
      duration: "1000",
      easing: "easeInExpo",
      properties: [
        {
          startValue: 0,
          endValue: -30,
          property: "rotate",
          unit: "deg",
        },
        {
          startValue: 0,
          endValue: -100,
          property: "translateX",
          unit: "%",
        },
        {
          startValue: 0,
          endValue: -600,
          property: "translateY",
        },
      ],
    },
  ];

  const portrait = [
    {
      start: "self",
      startOffset: 0,
      duration: 1000,
      easing: "easeInExpo",
      properties: [
        {
          startValue: 0,
          endValue: 45,
          property: "rotate",
          unit: "deg",
        },
        {
          startValue: 0,
          endValue: -300,
          property: "translateY",
        },
        {
          startValue: 0,
          endValue: 150,
          property: "translateX",
          unit: "%",
        },
      ],
    },
  ];

  const person = props.person;

  return (
    <>
      <div
        className="
          relative
          flex flex-wrap
          mb-12
        "
      >
        {/* 
          Wide green wrapper for name, role, company, language and talk title
          Image is also a child
        */}
        <Plx
          parallaxData={name}
          className="
            w-full
          "
        >
          <WrapRotation introZoomBack>
            <div
              className="
                flex flex-col
                px-3 lg:px-6 py-3
                bg-green
              "
            >
              {/* TYPE: Speaker */}
              {props.heroType === "speaker" && (
                <>
                  <h1 className="w-full mb-4 text-4xl uppercase motion-safe:animate-symbol-bounce-slow">
                    {person.name}
                  </h1>
                  {/* Role in company */}
                  <p className="w-full block font-bold">{person.stilling}</p>
                  <div className="w-full">
                    {/* Company name */}
                    {person.company ? (
                      <span className="inline-block mb-4 font-bold mr-1">
                        {person.company}
                      </span>
                    ) : null}

                    {/* Language tag */}
                    <div
                      className="
                        inline-block
                        pt-[0.1em] pr-[0.1em] pl-[0.1em] pb-[0.05em]
                        font-bold
                        border-3
                      "
                    >
                      {person.language && (
                        <p>{person.language.replace(/[\])}[{(]/g, "")}</p>
                      )}
                    </div>
                  </div>

                  {/* Talk title if applicable */}
                  {props.title ? (
                    <h2 className="mb-8 text-2xl uppercase">{props.title}</h2>
                  ) : (
                    ""
                  )}
                </>
              )}

              {/* TYPE: Talk / Workshop */}
              {(props.heroType === "talk" || props.heroType === "workshop") && (
                <>
                  <h1 className="w-full mb-4 text-4xl uppercase motion-safe:animate-symbol-bounce-slow">
                    {/* There are some real issues with the hyphenation plugin */}
                    {/* <Hyphenated> */}
                    {props.title}
                    {/* </Hyphenated> */}
                  </h1>
                  <h2 className="mb-4 text-2xl uppercase">{person.name}</h2>
                  {/* Role in company */}
                  <p className="w-full block font-bold">{person.stilling}</p>
                  <div className="w-full">
                    {/* Company name */}
                    <span className="inline-block mb-4 font-bold mr-1">
                      {person.company}
                    </span>
                    {/* Language tag */}
                    <div
                      className="
                        inline-block
                        pt-[0.05em] pr-[0.1em] pl-[0.1em] pb-[0em]
                        leading-[1.1]
                        font-bold
                        border
                      "
                    >
                      {person.language && (
                        <p>{person.language.replace(/[\])}[{(]/g, "")}</p>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </WrapRotation>
        </Plx>

        {/* Speaker image */}
        {person.image && (
          <div
            className="
              relative lg:absolute
              lg:right-0 lg:top-[70%]
              w-full lg:w-[40%]
              lg:pr-4
            "
            // -mt-4 lg:mt-0
          >
            <Plx parallaxData={portrait}>
              <WrapRotation introDelay={0.4} introZoomBack>
                <figure
                  className="
                      w-full
                    "
                >
                  <img
                    className="mx-auto w-full max-h-2-3 object-cover grayscale"
                    src={person.image.asset.url}
                    alt={person.name}
                  />
                </figure>
              </WrapRotation>
            </Plx>
          </div>
        )}

        {/* 
          Stage & time of day
          Give a negative top margin to compensate for gap created by speaker image
        */}
        {props.details && (
          <div
            className="
              text-lg uppercase font-bold
              pt-8
            "
          >
            <ul className="">
              {props.time && props.time.day && (
                <li>
                  <EmojiIcon name="presentation" /> {props.time.day},{" "}
                  {props.time.start} - {props.time.end}
                </li>
              )}
              {props.stage && (
                <li>
                  {props.stage.toLowerCase() === "online" ? (
                    <EmojiIcon name="livestream" animated className="mr-1" />
                  ) : (
                    <EmojiIcon name="stage" animated className="mr-1" />
                  )}
                  {props.stage}
                </li>
              )}
            </ul>
          </div>
        )}
      </div>
    </>
  );
};

export default SpeakerHero;
